import { useEffect, useRef } from 'react';

import { addDeviceAlias } from './brazeClient';

export function useBrazeDeviceAlias(isLoggedIn: boolean) {
  const aliasSetRef = useRef(false);

  useEffect(() => {
    if (!isLoggedIn) return;
    if (!window?.braze) return;
    if (aliasSetRef.current) return;

    addDeviceAlias();
    aliasSetRef.current = true;
  }, [isLoggedIn]);
}
